// Module
var code = "<div class=\"qp-msg-tooltip-container\"> <p class=\"msg-tooltip-title\">{{qpMsgTipTitle}}</p> </div>";
// Exports
export default code;